// extracted by mini-css-extract-plugin
export default {"table":"SMQCi4aAbmYmYINNQugY"};